import React from 'react';
import icons from '../../../constants/icons';
import { SvgIconProps } from '../../../types';

const SvgIcon: React.FC<SvgIconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  onClick,
  style
}) => {
  const iconData = icons[name as keyof typeof icons];
  let coloredIcon = iconData;
  if (!iconData) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  // Function to validate and process color
  const processColor = (color: string): string => {
    // Regex patterns for different color formats
    const HEX_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
    const RGB_PATTERN = /^rgb\((\d{1,3}%?,\s*){2}\d{1,3}%?\)$/;
    const RGBA_PATTERN = /^rgba\((\d{1,3}%?,\s*){3}(0|1|0?\.\d+)\)$/;
    const HSL_PATTERN = /^hsl\(\d{1,3},\s*\d{1,3}%,\s*\d{1,3}%\)$/;
    const HSLA_PATTERN = /^hsla\(\d{1,3},\s*\d{1,3}%,\s*\d{1,3}%,\s*(0|1|0?\.\d+)\)$/;
    const NAMED_COLOR_PATTERN = /^[a-zA-Z]+$/;

    // Validate color format
    if (
      HEX_PATTERN.test(color) ||
      RGB_PATTERN.test(color) ||
      RGBA_PATTERN.test(color) ||
      HSL_PATTERN.test(color) ||
      HSLA_PATTERN.test(color) ||
      NAMED_COLOR_PATTERN.test(color)
    ) {
      return color;
    }

    // Default to currentColor if invalid
    return 'currentColor';
  };
if(iconData){
    coloredIcon = iconData.replace(
    /fill=['"]?[^'"]*['"]?/g, 
    `fill="${processColor(color)}"`
  );
}

  return (
    <span
      className={`flex cursor-pointer items-center justify-center ${className}`}
      onClick={onClick}
      style={{
        ...style,
      }}
    >
      <img 
        srcSet={`${coloredIcon} 1x, ${coloredIcon} 2x`}
        loading="lazy"
        src={coloredIcon}
        width={size}
        height={size}
        alt={name}
        style={{
          display: 'block',
          width: size,
          height: size
        }}
      />
    </span>
  );
};

export default SvgIcon;
